import React from 'react';
import { usePopupState, bindTrigger, bindMenu } from 'material-ui-popup-state/hooks';

import IconButton from '@mui/material/IconButton';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import Menu from '@mui/material/Menu';
import Stack from '@mui/material/Stack';
import CascadingMenuContext from './components/CascadingMenuContext';
import { MoreMenuItem } from './components/CascadingMenu';

const ContextMenuButton = ({ options, contextMenuName }) => {
  const popupState = usePopupState({ variant: 'popover', popupId: `${contextMenuName}ContextMenu` });

  return (
    <Stack justifyContent="center" alignItems="center" flex={1} height="100%">
      <IconButton sx={{ fontSize: '22px' }} {...bindTrigger(popupState)}>
        <MoreHorizIcon fontSize="inherit" />
      </IconButton>
      {!!options.length && (
        <Menu
          autoFocus
          transformOrigin={{ horizontal: 'right', vertical: 'bottom' }}
          anchorOrigin={{ horizontal: 'right', vertical: 'top' }}
          {...bindMenu(popupState)}
        >
          <CascadingMenuContext.Provider value={{ rootPopupState: popupState, parentPopupState: popupState }}>
            {options.map((option) => (
              <MoreMenuItem option={option} key={option.id} />
            ))}
          </CascadingMenuContext.Provider>
        </Menu>
      )}
    </Stack>
  );
};

export default ContextMenuButton;
